module.exports = __webpack_public_path__ + "img/gou-fff.df9c00e6.svg";